import { requirementCourseEnrollmentContract } from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";
import { type z } from "zod";

const completeCourseEnrollmentRequestSchema =
  requirementCourseEnrollmentContract.updateRequirementCourseEnrollment.body;
const { 200: completeCourseEnrollmentResponseSchema } =
  requirementCourseEnrollmentContract.updateRequirementCourseEnrollment.responses;

export type CompleteCourseEnrollmentRequest = z.input<typeof completeCourseEnrollmentRequestSchema>;
export type CompleteCourseEnrollmentResponse = z.infer<
  typeof completeCourseEnrollmentResponseSchema
>;

interface MutationVariables {
  courseEnrollmentId: string;
  request: CompleteCourseEnrollmentRequest;
}

export function useCompleteCourseEnrollment() {
  return useMutation({
    mutationFn: async ({ courseEnrollmentId, request }: MutationVariables) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/requirement-course-enrollments/${courseEnrollmentId}`,
        data: request,
        requestSchema: completeCourseEnrollmentRequestSchema,
        responseSchema: completeCourseEnrollmentResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: "Failed to complete course enrollment",
    },
  });
}
